import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "../pages/LoginPage";
import AuthPage from "../pages/AuthPage";
import ForgotPasswordPage from "../pages/ForgotPasswordPage";
import ResetPasswordPage from "../pages/ResetPasswordPage";
import Dashboard from "../pages/Dashboard";
import ClockInClockOut from "../pages/ClockInClockOut";
import NotFound from "../components/NotFound";
import { useUser } from "../context/UserContext";
import AdminPanel from "../components/AdminPanel";
import { Flex, Spinner } from "@chakra-ui/react";
import MyProfile from "../pages/MyProfile";
import Ticketing from "../pages/Ticketing.js";
import ComingSoon from "../pages/ComingSoon.jsx";
import Categories from "../pages/Categories";
import CategoryMaterials from "../pages/CategoryMaterials";
import ProductDetails from "../pages/ProductDetails";
import POSCountersPage from "../modules/pos/POSCountersPage.jsx";
import TransactionsPage from "../modules/pos/TransactionsPage.jsx";
import CashierScreen from "../components/CashierScreen.jsx";
import Cart from "../pages/Cart.jsx";
import Checkout from "../pages/Checkout.jsx";
import ModuleProtectedRoute from "../components/ModuleProtectedRoute";
import RentalsRoutes from "../modules/rentals/routes/index.jsx";
import Staff from "../pages/Staff";
import RBAC from "../modules/rbac/components/RBAC.js";
import MaterialMaster from "../pages/MaterialMaster";
import MaterialCreate from "../pages/MaterialCreate";
import MaterialEdit from "../pages/MaterialEdit";
import MarketplaceRoutes from "../modules/novatra/marketplace/routes";

const ProtectedRoute = ({ children }) => {
  const { loggedInUser, isLoading } = useUser();

  if (isLoading) {
    return (
      <Flex justify="center" align="center" height="100vh">
        <Spinner size="xl" color="teal.500" />
      </Flex>
    );
  }
  console.log("loggedInUser", loggedInUser);

  return loggedInUser ? children : <Navigate to="/login" />;
  // return loggedInUser ? children : null;
};

const AppRoutes = () => (
  <Routes>
    {/* Auth routes */}
    <Route path="/login" element={<AuthPage />} />
    <Route path="/auth" element={<AuthPage />} />
    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
    <Route path="/reset-password" element={<ResetPasswordPage />} />

    <Route path="/MyProfile" element={<MyProfile />} />

    {/* ✅ Admin layout wrapper */}
    <Route
      path="/"
      element={
        <ProtectedRoute>
          <AdminPanel />
        </ProtectedRoute>
      }
    >
      {/* ✅ These go inside <Outlet /> */}
      <Route index element={<Dashboard />} />
      <Route path="categories" element={<Categories />} />
      <Route path="categories/:categoryId" element={<CategoryMaterials />} />
      <Route path="categories/:categoryId/:materialId" element={<ProductDetails />} />
      <Route path="Ticketing" element={<Ticketing />} />
      <Route path="clockin" element={<ClockInClockOut />} />
      <Route path="ComingSoon" element={<ComingSoon />} />
      <Route path="/pos" element={<POSCountersPage />} />
      <Route path="/Excel" element={<CashierScreen />} />
      <Route path="cart" element={<Cart />} />
      <Route path="checkout" element={<Checkout />} />
      <Route path="/transactions" element={<TransactionsPage />} />
      <Route path="staff" element={<RBAC />} />
      <Route path="materials" element={<MaterialMaster />} />
      <Route path="materials/new" element={<MaterialCreate />} />
      <Route path="materials/:id/edit" element={<MaterialEdit />} />
      <Route path="novatra/marketplace/*" element={<MarketplaceRoutes />} />
      {/* Rentals module - mounted only when tenant has module enabled */}
      <Route
        path="rentals/*"
        element={
          <ModuleProtectedRoute moduleName="rentals">
            <RentalsRoutes />
          </ModuleProtectedRoute>
        }
      />

      <Route path="*" element={<NotFound />} />
    </Route>
  </Routes>
);

export default AppRoutes;
